<div zoomed>
	<div class="toolbar">
		<app-toolbar></app-toolbar>
	</div>
	<router-outlet (activate)="onActivate($event)"></router-outlet>
</div>